import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { LookupCriteria, LookupItemViewModel, } from "@tylertech/tyler-api-types";

export interface EntityLookup
{
    key: string;
    value: string;
}

@Injectable()
export class EntitySuggestService
{
    constructor(
        private readonly $apiService: ApiService
    ) { }

    getRegisteredEntities(): Promise<ReadonlyArray<EntityLookup>>
    {
        return this.$apiService.sendAuth("IEntitySuggestService/GetRegisteredEntities")
            .then((result) =>
            {
                return Object.entries(result)
                    .map(([key, value]: [string, string]) =>
                    {
                        return {
                            key,
                            value
                        } as EntityLookup;
                    });
            });
    }

    getTodoEntitySuggestions(criteria: LookupCriteria): Promise<LookupItemViewModel[]>
    {
        return this.$apiService.sendAuth("IEntitySuggestService/GetSuggestions", criteria);
    }
}
